export const INFOGRAPH_URL = 'https://infograph.venngage.com';

export const STAGING_INFOGRAPH_URL = 'https://infograph.venngage.beer';

// [Local only] This is e2 api endpoint that only needs for frontend works in local env
export const API_DOMAIN = import.meta.env.VITE_INFOGRAPH_API_DOMAIN;

// [Standalone only] This is e2 api JWT that only needs for standalone env
export const STANDALONE_API_KEY = import.meta.env.VITE_INFOGRAPH_API_KEY;

export const HELP_INFOGRAPH_URL = 'https://help.venngage.com';
